import type { RouteObject } from "react-router-dom";
import Home from "@/pages/home/page";
import StatementsPage from "@/pages/statements/page";
import StatementDetail from "@/pages/statements/detail/page";
import AboutPage from "@/pages/about/page";
import FaqPage from "@/pages/faq/page";
import ContactPage from "@/pages/contact/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/statements",
    element: <StatementsPage />,
  },
  {
    path: "/statements/:id",
    element: <StatementDetail />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/faq",
    element: <FaqPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;